import { useState, useEffect, useRef } from 'react';

export const useSelectCompetitorsButton = () => {
	const [competitorSelectActive, setCompetitorSelectActive] =
		useState<boolean>(false);

	const selectButtonRef = useRef<HTMLDivElement | null>(null);
	const selectCompetitorsDropdownRef = useRef<HTMLDivElement | null>(null);

	const handleClickOutsideSelectButton = (event: MouseEvent) => {
		if (
			selectButtonRef.current &&
			selectButtonRef.current.contains(event.target as Node)
		) {
			return;
		}

		if (
			selectCompetitorsDropdownRef.current &&
			selectCompetitorsDropdownRef.current.contains(event.target as Node)
		) {
			return;
		}

		setCompetitorSelectActive(false);
	};

	useEffect(() => {
		document.addEventListener('mousedown', handleClickOutsideSelectButton);

		return () => {
			document.removeEventListener(
				'mousedown',
				handleClickOutsideSelectButton
			);
		};
	}, []);

	// This hook hide the competitors dropdown when table scroll is active
	// It is implemented because when opened dropdown is at frozen part of the table
	// some part of it remains visible
	useEffect(() => {
		// Because dropdown itself is inside portal
		// to align it with competitors button
		// we get position of the button
		// and put the dropdown below
		const formatDropdownPosition = () => {
			const dropdown = selectCompetitorsDropdownRef.current;

			const rect = selectButtonRef.current?.getBoundingClientRect();

			if (rect && dropdown) {
				const top = rect.bottom + window.scrollY;
				const left = rect.left + window.scrollX;

				dropdown.style.top = `${top}px`;
				dropdown.style.left = `${left}px`;
			}
		};

		formatDropdownPosition();

		const parentContainer = document.getElementById('manual-input-table');

		if (!parentContainer) {
			return;
		}

		const tableScroll =
			parentContainer.querySelector(`.p-datatable-wrapper`);

		if (!tableScroll) {
			return;
		}

		const handleScroll = () => {
			setCompetitorSelectActive(false);
		};

		tableScroll.addEventListener('scroll', handleScroll);

		return () => {
			tableScroll.removeEventListener('scroll', handleScroll);
		};
	}, [competitorSelectActive]);

	return {
		competitorSelectActive,
		setCompetitorSelectActive,
		selectButtonRef,
		selectCompetitorsDropdownRef
	};
};
